import PropTypes from 'prop-types';
import React from 'react';

import { Dispatcher as IconDispatcher } from '$partials/icon';
import { Button } from '$partials/ui';
import { Image } from '$partials/media';
import { useLanguage } from '$contexts/language.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const PeopleItem = ({
    displayLocation = null,
    emailAddress    = null,
    image           = null,
    role            = null,
    title           = null,
    url             = null
}) => {
    // hooks
    const { translate: t } = useLanguage();

    // render
    return (
        <div className='expand-interaction hover-image-scale'>
            {/* image */}
            {image && (
                <figure className='border-rad-10 font-0 mt5 sm-mt0 md-mt0'>
                    <Image
                        {...image}
                        containerClassName='hover-image-scale-target' />
                </figure>
            )}

            <dl>
                {/* name */}
                <dt className='accessible-hide'>
                    {t('Name')}
                </dt>

                <dd className='pb3 pt4 border-bottom border-black'>
                    {url && (
                        <Button
                            className='width-100 items-center justify-between expand-interaction__action'
                            href={url}>
                            <span className='type-style-3'>
                                {title}
                            </span>

                            <span className='mrn3'>
                                <IconDispatcher name='IconArrowRight' />
                            </span>
                        </Button>
                    )}

                    {!url && (
                        <span className='type-style-3'>
                            {title}
                        </span>
                    )}
                </dd>

                {/* role */}
                <dt className='accessible-hide'>
                    {t('Role')}
                </dt>

                {role && (
                    <dd className='type-style-6 pb3 pt4 border-bottom border-black hans-purple'>
                        {role}
                    </dd>
                )}

                {/* location */}
                <dt className='accessible-hide'>
                    {t('Location')}
                </dt>

                {displayLocation && (
                    <dd className='type-style-6 pb3 pt4 border-bottom border-black hans-purple'>
                        {displayLocation}
                    </dd>
                )}

                {/* email */}
                <dt className='accessible-hide'>
                    {t('Email')}
                </dt>

                {emailAddress && (
                    <dd className='pb3 pt6'>
                        <Button
                            className='button'
                            href={`mailto:${emailAddress}`}
                            rel='noopenner noreferrer'
                            target='_blank'>
                            <span className='capitalise'>
                                {t('Contact')}
                            </span>
                        </Button>
                    </dd>
                )}
            </dl>
        </div>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

PeopleItem.propTypes = {
    displayLocation: PropTypes.string,
    emailAdress    : PropTypes.string,
    email          : PropTypes.string,
    image          : PropTypes.object,
    role           : PropTypes.string,
    title          : PropTypes.string,
    url            : PropTypes.string
};

PeopleItem.__typename = 'People';

export { PeopleItem };

export default PeopleItem;
